module.exports = __webpack_public_path__ + "fonts/nucleo-icons.b0dc05d0.ttf";